// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Rqcpe","bannerIcon":"y0UNQ","bannerName":"rlzYr","bannerContent":"iHpMw","bannerText":"_AIHV","bannerButton":"KnPV9","bannerDescription":"d4UG0"};